import React from "react";
import { formatDateRange } from "../../utils/format";

export interface CommunityPriceCardDurationProps {
  activeFrom?: string | null;
  activeTill?: string | null;
  className?: string;
}

export const CommunityPriceCardDuration: React.FC<CommunityPriceCardDurationProps> = React.memo(
  ({ activeFrom, activeTill, className }) => (
    <div className={`text-sm text-600 ${className ?? ""}`}>
      {formatDateRange(activeFrom ?? null, activeTill ?? null)}
    </div>
  )
);